import { BASE_URL, GET, ON_BORDING_REQUEST } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchOnBoardingRequestDetail = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${ON_BORDING_REQUEST}/${requestId}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};
